import styled from 'styled-components';

export const StyledMap = styled.div`
  width: 100%;
  height: 100%;
  min-height: 400px;

  @media only screen and (min-width: 1023px) {
    min-height: 600px;
  }
`;
